import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_MENU_TITLE_DISH_COUNTS,
  RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS,
  SET_MENU_TITLE_EXPANDED_ROW_KEYS,
  SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE,
  SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY,
  UPDATE_MENU_TITLE,
} from '../action-types'
import { MENU_TITLE_INITIAL_STATE } from '../initial-states'

const menuTitleReducer = (state = MENU_TITLE_INITIAL_STATE, action) => {
  switch (action.type) {
    case RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: true,
          updateError: null,
        }),
      )

    case RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS.COMPLETE:
      return produce(state, nextState => {
        const { retryMenuTitleLabelsAndIngredients: awaitingStatus } =
          action.payload.data

        assign(nextState.data, { awaitingStatus })
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case UPDATE_MENU_TITLE.START:
      return produce(state, nextState => {
        assign(nextState, {
          updateMenuTitleError: undefined,
          updateMenuTitleLoading: true,
          updateMenuTitleId: action.payload.id,
        })
      })

    case UPDATE_MENU_TITLE.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          updateMenuTitleError: undefined,
          updateMenuTitleLoading: false,
          updateMenuTitleId: action.payload.id,
        })
      })

    case UPDATE_MENU_TITLE.FAIL:
      return produce(state, nextState => {
        assign(nextState, {
          updateMenuTitleError: action.error.message,
          updateMenuTitleLoading: false,
          updateMenuTitleId: action.payload.id,
        })
      })

    case FETCH_MENU_TITLE_DISH_COUNTS.START:
      return produce(state, nextState => {
        assign(nextState, {
          menuTitleDishCountsError: undefined,
          menuTitleDishCountsLoading: true,
        })
      })

    case FETCH_MENU_TITLE_DISH_COUNTS.COMPLETE:
      return produce(state, nextState => {
        const { menuTitleDishCounts } = action.payload.data

        assign(nextState, {
          menuTitleDishCountsError: undefined,
          menuTitleDishCountsLoading: false,
          menuTitleDishCounts,
        })
      })

    case FETCH_MENU_TITLE_DISH_COUNTS.FAIL:
      return produce(state, nextState => {
        assign(nextState, {
          menuTitleDishCountsError: action.error.message,
          menuTitleDishCountsLoading: false,
          updateMenuTitleId: action.payload.id,
        })
      })

    case SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE:
      return produce(state, nextState => {
        assign(nextState, {
          menuTitleForIgnoredDishType: action.payload.menuTitle,
        })
      })

    case SET_MENU_TITLE_EXPANDED_ROW_KEYS:
      return produce(state, nextState => {
        assign(nextState, {
          menuTitleExpandedRowKeys: action.payload || [],
        })
      })

    case SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY:
      return produce(state, nextState => {
        assign(nextState, {
          menuTitleHighlightedRowKey: action.payload,
        })
      })

    default:
      return state
  }
}

export default menuTitleReducer
